import * as React from "react";
const YoutubeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={18.75} {...props}>
    <g data-name="Group 47575">
      <path
        fill="#0e5492"
        d="M0 15.625v-12.5A3.125 3.125 0 0 1 3.125 0h18.75A3.125 3.125 0 0 1 25 3.125v12.5a3.125 3.125 0 0 1-3.125 3.125H3.125A3.125 3.125 0 0 1 0 15.625ZM10.609 4.833a.781.781 0 0 0-1.234.636v7.813a.781.781 0 0 0 1.234.636l5.469-3.906a.781.781 0 0 0 0-1.272Z"
        data-name="Path 37266"
      />
    </g>
  </svg>
);
export default YoutubeIcon;
